import { XMarkIcon } from "@heroicons/react/24/outline"
import React, { useState } from "react"

import { normalizeBlogTagInput } from "../Blog/blogTagUtils"

const BlogPostTagInput = ({ tags = [], onChange, maxTags = 10 }) => {
  const [inputValue, setInputValue] = useState("")

  const addTag = (raw) => {
    const tag = normalizeBlogTagInput(raw)
    if (!tag || tags.includes(tag) || tags.length >= maxTags) return
    onChange([...tags, tag])
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault()
      addTag(inputValue)
      setInputValue("")
    } else if (event.key === "Backspace" && !inputValue && tags.length > 0) {
      onChange(tags.slice(0, -1))
    }
  }

  const removeTag = (indexToRemove) => {
    onChange(tags.filter((_, index) => index !== indexToRemove))
  }

  return (
    <div className="relative w-full rounded-lg border border-builder-border bg-white">
      <div className="flex min-h-[44px] flex-wrap gap-2 px-3 py-2">
        {tags.map((tag, index) => (
          <span
            key={`${tag}-${index}`}
            className="inline-flex items-center gap-1 rounded-full bg-builder-border-light px-3 py-1 text-[13px] text-builder-primary">
            {tag}
            <button
              type="button"
              onClick={() => removeTag(index)}
              className="rounded-full p-0.5 hover:bg-builder-border"
              aria-label={`Remove tag ${tag}`}>
              <XMarkIcon className="size-3 text-builder-secondary" />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={(event) => setInputValue(event.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={() => {
            if (inputValue.trim()) {
              addTag(inputValue)
              setInputValue("")
            }
          }}
          placeholder={tags.length === 0 ? "Type a tag and press Enter" : ""}
          disabled={tags.length >= maxTags}
          className="min-w-[120px] flex-1 bg-transparent text-sm text-builder-primary outline-none placeholder:text-builder-border disabled:cursor-not-allowed"
        />
      </div>
    </div>
  )
}

export default BlogPostTagInput
